import React from 'react';
import { Button, IconButton } from '@chakra-ui/react';
import { ExportReason, ReleaseExport } from 'types/releases';
import { ReactComponent as DownloadIcon } from 'resources/images/download.svg';
import { Link } from 'types/api.types';
import { AccountConnectionProviderId } from 'types/profile';
import { ExportConnexReleaseFormValues } from './types';

interface ExportSendLabelV2ReleaseProps {
  isReadyForExportReason?: ExportReason;
  exportRelease: (
    data: ExportConnexReleaseFormValues,
    accountConnectionGuid?: string
  ) => Promise<ReleaseExport>;
  releaseExportLink?: Link;
  handleOnConnect: (providerId: AccountConnectionProviderId) => Promise<void>;
  isInvalid: boolean;
}

export const ExportSendLabelV2Release: React.FC<ExportSendLabelV2ReleaseProps> = ({
  isReadyForExportReason,
  exportRelease,
  releaseExportLink,
  handleOnConnect,
  isInvalid,
}) => {
  const isDisabled = !releaseExportLink || isReadyForExportReason !== 'Ready';

  return (
    <>
      <Button
        size="sm"
        onClick={() => handleOnConnect('Connex')}
        title={
          isDisabled || isInvalid ? 'Please first resolve any data issue' : ''
        }
        isDisabled={isDisabled || isInvalid}
      >
        Export Release
      </Button>
      <IconButton
        variant="text"
        title="Download PDF"
        icon={<DownloadIcon />}
        aria-label="Download"
        size="xs"
        onClick={() => exportRelease({ shipmentStrategy: 'LabelCopy' })}
        isDisabled={isDisabled}
      />
    </>
  );
};
